/** "f" = femenino, "m" = masculino: género gramatical del nombre de los puntos. */
export type PointCurrencyGender = "f" | "m";

/** Nombre de los puntos: singular, plural y género van siempre juntos. */
export interface PointCurrencyName {
  singular: string;
  plural: string;
  gender: PointCurrencyGender;
}

/**
 * Las 3 plantillas del mensaje de puntos en el detalle de evento, ya resueltas (configurada o,
 * si no hay, el default). Nunca vacías.
 */
export interface EventPointsMessageTemplates {
  titleTemplate: string;
  attendanceClauseTemplate: string;
  bonusClauseTemplate: string;
}

/**
 * Lo que configuró el tenant. A diferencia del nombre de los puntos (los 3 juntos o ninguno),
 * cada plantilla es independiente: `null` en una sola no afecta a las otras dos.
 */
export interface ConfiguredEventPointsMessageTemplates {
  titleTemplate: string | null;
  attendanceClauseTemplate: string | null;
  bonusClauseTemplate: string | null;
}

/** GET /bo/points/settings. El tenant sale del scope (X-Tenant-Context). */
export interface PointSettings {
  /** Lo que configuró el tenant; null = no configuró nada y usa el default. */
  currencyName: PointCurrencyName | null;
  /** Lo que ve el usuario en la app: el configurado o, si no hay, el default del backend. */
  effectiveCurrencyName: PointCurrencyName;
  rulesArticleId: string | null;
  eventPointsMessageTemplates: ConfiguredEventPointsMessageTemplates;
  effectiveEventPointsMessageTemplates: EventPointsMessageTemplates;
  /** Texto de invitación que configuró el tenant; null = no configuró y usa el default. */
  referralShareText: string | null;
  /** Lo que la app antepone al link hoy: el configurado o, si no hay, el default del backend. */
  effectiveReferralShareText: string;
}

/** Body de PUT /bo/points/settings en camelCase. `null` en cada campo lo desconfigura. */
export interface UpdatePointSettingsPayload {
  currencyName: PointCurrencyName | null;
  rulesArticleId: string | null;
  eventPointsMessageTemplates: ConfiguredEventPointsMessageTemplates;
  /** `null` lo vuelve al default. */
  referralShareText: string | null;
}

/** El nombre que usa el backend cuando el tenant no configuró ninguno. */
export const DEFAULT_POINT_CURRENCY_NAME: PointCurrencyName = {
  singular: "Punto",
  plural: "Puntos",
  gender: "m",
};

/** Largo máximo de singular y plural. El backend lo valida igual. */
export const POINT_CURRENCY_NAME_MAX_LENGTH = 24;

/** Lo que usa el backend por cada plantilla que el tenant no configuró. */
export const DEFAULT_EVENT_POINTS_MESSAGE_TEMPLATES: EventPointsMessageTemplates = {
  titleTemplate: "Sumá {total} {currency} por asistir!",
  attendanceClauseTemplate: "{attendance} por asistencia",
  bonusClauseTemplate: "+{bonus} bonus de este evento",
};

/** Largo máximo de cada plantilla. El backend lo valida igual. */
export const EVENT_POINTS_MESSAGE_TEMPLATE_MAX_LENGTH = 200;

/** El texto de invitación que usa el backend cuando el tenant no configuró ninguno. */
export const DEFAULT_REFERRAL_SHARE_TEXT = "Sumate a Grups con mi link";

/** Largo máximo del texto de invitación. El backend lo valida igual. */
export const REFERRAL_SHARE_TEXT_MAX_LENGTH = 100;
